import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils';

const BASE_CLASS = 'filtermenu';

// Blue Bar
// .moz-filtermenu
export const BarWrapper = styled({
  base: 'div',
  mozClassName: `${BASE_CLASS}`
}, ({ $palette }) => ({
  minHeight: '60px',
  position: 'relative',
  backgroundColor: `${$palette('SECONDARY').lighten(5)}`,
}));

export const Bar = styled('div', {
  maxWidth: '920px',
  margin: '10px auto',
  minHeight: '40px',
  display: 'flex',
  flexWrap: 'nowrap',
  ...getScreenStyles('sm', {
    margin: '10px 8px'
  })
});

export const Group = styled('div', ({ $right }) => ({
  'display': 'flex',
  'flexGrow': 1,
  'justifyContent': $right ? 'flex-end' : 'flex-start',
  'alignItems': 'center'
}));

export const HideMobile = styled('div', {
  ...getScreenStyles('xs', {
    display: 'none'
  })
});

// Buttons and Labels
export const ButtonSpacer = styled('div', {
  marginRight: '16px',
  ...getScreenStyles('xs', {
    marginRight: '0'
  })
});

export const SortByLabel = styled('span', ({ $palette }) => ({
  marginRight: '5px',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  fontFamily: 'Manrope',
  textTransform: 'uppercase',
  fontSize: '7pt',
  color: `${$palette('GRAY')}`,
}));

// Share
export const ShareContainer = styled('div', {
  margin: '16px'
});

export const FiltersContainer = styled('div', {
  margin: '8px 0 16px 16px'
});

export const Title = styled('h3', {
  fontFamily: 'Manrope',
  fontWeight: 200,
  fontSize: '20px'
});

export const IconSpace = styled('span', {
  display: 'inline-block',
  marginRight: '16px'
});

export const FilterOption = styled('div', {
  padding: '14px 14px 14px 0',
  borderBottom: '1px solid  #e1e1e1'
});

export const MeetAndGreet = styled('span', {
  textDecoration: 'underline'
});

export const Inline = styled('div', {
  display: 'inline-block'
});

export const Badge = styled('span', ({ $palette }) => ({
  background: `${$palette('WHITE')}`,
  color: `${$palette('SECONDARY')}`,
  width: '12px',
  height: '12px',
  display: 'inline-block',
  borderRadius: '10px',
  fontSize: '8px',
  textAlign: 'center',
  lineHeight: '13px',
  marginTop: '-1px',
  fontWeight: 'bold',
  marginLeft: '8px'
}));

export const NumberFieldWrapper = styled('div', {
  display: 'inline-block',
  maxWidth: '76px',
  marginLeft: '12px',
  marginTop: '-10px',
  ...getScreenStyles('xs', {
    marginRight: '0',
    maxWidth: '90px'
  })
});

export const FilterSuitcase = styled('div', {
  display: 'flex',
  justifyContent: 'space-between'
});

export const FilterSupplierScoreContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between'
})

export const StrongMessage = styled('strong', {
  display: 'inline-block',
  marginRight: '4px'
});

// Wrap FormattedMessage from checkbox to make label black
// kepping checkbox blue
export const BlackLabel = styled('span', ({ $palette }) => ({
  color: `${$palette('TEXT')}`,
  fontSize: '13px'
}));

export const ButtonWrapper = styled('div', {
  marginRight: '16px',
  display: 'flex',
  flexFlow: 'row nowrap',
});

export const FilterTopSpacer = styled('div', {
  '@media (max-height: 722px)': {
    marginTop: '50px',
  },
});